import { render, staticRenderFns } from "./GuardIcon.vue?vue&type=template&id=6e6d8bcc&scoped=true&"
import script from "./GuardIcon.vue?vue&type=script&lang=js&"
export * from "./GuardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d8bcc",
  null
  
)

export default component.exports